import { GetInspectionsRequest } from './getSchedules'

export const schedulesQueryKeys = {
  all: () => ['schedules'],
  claims: () => [...schedulesQueryKeys.all(), 'claims'],
  claimsSchedules: (request: GetInspectionsRequest) => [...schedulesQueryKeys.claims(), request],
}
